import { WEAPON_SEQUENCE, WeaponType } from '../utils/constants';

/**
 * Small squads need precision help because one straight bullet otherwise has a
 * much narrower useful lane than a touch-controlled finger can reliably hold.
 * The assist fades as formation width creates its own natural coverage.
 */
export function getLowCountAimAssistPadding(soldierCount: number): number {
  if (soldierCount <= 2) return 9;
  if (soldierCount <= 5) return 7;
  if (soldierCount <= 10) return 3;
  return 0;
}

/**
 * Each campaign band teaches one firing rhythm before introducing the next.
 * Runs restart with the pistol, so allowing every level to reach the rocket
 * made early progression feel random and invalidated the finale DPS budget.
 */
export function getWeaponCeilingForLevel(level: number): WeaponType {
  const normalizedLevel = Math.max(1, Math.min(10, Math.round(level)));
  if (normalizedLevel <= 3) return WeaponType.Rifle;
  if (normalizedLevel <= 7) return WeaponType.MachineGun;
  return WeaponType.Rocket;
}

export function getNextWeaponIndexForLevel(
  currentWeaponIndex: number,
  level: number
): number | null {
  const normalizedCurrentIndex = Math.max(0, Math.round(currentWeaponIndex));
  const nextWeaponIndex = normalizedCurrentIndex + 1;
  const ceilingIndex = WEAPON_SEQUENCE.indexOf(getWeaponCeilingForLevel(level));
  return nextWeaponIndex <= ceilingIndex ? nextWeaponIndex : null;
}

/** Equips the crate's authored tier without letting an older live crate downgrade or double-upgrade it. */
export function getWeaponAfterPickup(
  currentWeapon: WeaponType,
  offeredWeapon: WeaponType
): WeaponType {
  const currentIndex = WEAPON_SEQUENCE.indexOf(currentWeapon);
  const offeredIndex = WEAPON_SEQUENCE.indexOf(offeredWeapon);
  if (offeredIndex < 0) return currentWeapon;
  return WEAPON_SEQUENCE[Math.max(0, currentIndex, offeredIndex)];
}
